import React from "react";

import PerfectScrollbar from "react-perfect-scrollbar";

import useSidebar from "../../hooks/useSidebar";
import SidebarNav from "./SidebarNav";
import Logo from "../../assets/img/nordomatic_white.png";

const Sidebar = ({items}) => {
    const {isOpen} = useSidebar();

    if (!isOpen) return <></>
    return (
        <nav className={`sidebar ${!isOpen ? "collapsed" : ""}`}>
            <div className="sidebar-content">
                <PerfectScrollbar>
                    <div className="sidebar-brand">
                        <img src={Logo} width={150}/>
                    </div>

                    <SidebarNav items={items}/>
                </PerfectScrollbar>
            </div>
        </nav>
    );
};

export default Sidebar;
